import { PropTypes } from 'prop-types';
import React from 'react';

function MissedCall(props) {
  const { fill } = props;
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_699_237201)">
        <path
          d="M12.3083 20.7833L12.3166 20.7892C13.0367 21.2476 13.8916 21.4467 14.7401 21.3535C15.5886 21.2603 16.3799 20.8805 16.9833 20.2767L17.5075 19.7525C17.6236 19.6364 17.7158 19.4986 17.7786 19.3469C17.8415 19.1952 17.8739 19.0325 17.8739 18.8683C17.8739 18.7041 17.8415 18.5415 17.7786 18.3898C17.7158 18.2381 17.6236 18.1002 17.5075 17.9842L15.2966 15.775C15.1805 15.6588 15.0427 15.5667 14.891 15.5038C14.7393 15.4409 14.5767 15.4086 14.4125 15.4086C14.2482 15.4086 14.0856 15.4409 13.9339 15.5038C13.7822 15.5667 13.6444 15.6588 13.5283 15.775C13.2939 16.0093 12.976 16.141 12.6445 16.141C12.3131 16.141 11.9952 16.0093 11.7608 15.775L8.22579 12.2392C7.99145 12.0047 7.85981 11.6869 7.85981 11.3554C7.85981 11.024 7.99145 10.7061 8.22579 10.4717C8.34195 10.3556 8.43409 10.2177 8.49696 10.066C8.55983 9.91432 8.59219 9.75171 8.59219 9.58749C8.59219 9.42327 8.55983 9.26066 8.49696 9.10895C8.43409 8.95724 8.34195 8.81941 8.22579 8.70332L6.01579 6.49416C5.78138 6.25982 5.46349 6.12817 5.13204 6.12817C4.80058 6.12817 4.4827 6.25982 4.24829 6.49416L3.72329 7.01832C3.11961 7.62181 2.73989 8.41318 2.64686 9.26168C2.55382 10.1102 2.75305 10.965 3.21162 11.685L3.21662 11.6933C5.63844 15.2765 8.72469 18.3622 12.3083 20.7833Z"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M13.9064 10.0935C15.615 11.8021 18.385 11.8021 20.0936 10.0935C21.8021 8.38498 21.8021 5.61488 20.0936 3.90634C18.385 2.19779 15.615 2.19779 13.9064 3.90634C12.1979 5.61488 12.1979 8.38498 13.9064 10.0935Z"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M18.3258 5.67407L15.6742 8.32572"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M15.6742 5.67407L18.3258 8.32572"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
      </g>
      <defs>
        <clipPath id="clip0_699_237201">
          <rect fill="white" height="20" transform="translate(2 2)" width="20" />
        </clipPath>
      </defs>
    </svg>
  );
}

MissedCall.propTypes = {
  fill: PropTypes.string.isRequired
};

export default MissedCall;
